__webpack_require__.p = "/local/templates/lafa.ru/assets/application/dist/";